import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getReport} from '../../../apis/report/getReport'

const PAGE_SIZE = 10

const useQueryReport = (currentPage: number = 1) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.other.getReport(currentPage),
        cacheTime: 60 * 1000,
        staleTime: 60 * 1000,
        queryFn: async () => {
            const {data, pageInfo} = await getReport(PAGE_SIZE, currentPage)
            return {data, pageInfo}
        },
    })

    return {data, refetch}
}

export default useQueryReport
